module.exports = __webpack_public_path__ + "img/opex.f78827c4.svg";